import { render, staticRenderFns } from "./EventTypeDetail.vue?vue&type=template&id=3635580d&scoped=true"
import script from "./EventTypeDetail.vue?vue&type=script&lang=js"
export * from "./EventTypeDetail.vue?vue&type=script&lang=js"
import style0 from "./EventTypeDetail.vue?vue&type=style&index=0&id=3635580d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3635580d",
  null
  
)

export default component.exports